import { render, staticRenderFns } from "./TheStepsContacts.vue?vue&type=template&id=15911872&"
import script from "./TheStepsContacts.vue?vue&type=script&lang=js&"
export * from "./TheStepsContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports